import { render, staticRenderFns } from "./IconTriangle.vue?vue&type=template&id=1a27378d&"
import script from "./IconTriangle.vue?vue&type=script&lang=js&"
export * from "./IconTriangle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports